import { Button, Dot } from 'components/Blocks';

import { projectStatusByCode, TaskWithSub } from 'entities';

import { useProjectById } from 'providers/Project';

interface ProjectLinkProps {
  children?: never;
  task: TaskWithSub;
}

export function ProjectLink({ task }: ProjectLinkProps) {
  const project = useProjectById(task.projectId);

  return (
    <Button to="projectProfile" params={task} variant="link">
      {project.name}

      <Dot color={projectStatusByCode[project.status].color} />
    </Button>
  );
}
